import { LANGUAGES } from "./constants";

export const createLanguageOptions = () => {
  return Object.values(LANGUAGES).map((lang) => ({ name: lang, value: lang }));
};
